module.exports = __webpack_public_path__ + "img/HP Griglia 4.8f5aa6b1.webp";